import type { MerchantServiceRow } from '../../services/analytics.api';
import { Panel } from '../ui/Panel';
import { tbl } from '../ui/table';
import { cn } from '../../utils/cn';

function MerchantTable({ rows, emptyText }: { rows: MerchantServiceRow[]; emptyText: string }) {
  if (rows.length === 0) return <p className={tbl.empty}>{emptyText}</p>;
  return (
    <div className={tbl.wrap}>
      <table className={tbl.table}>
        <thead>
          <tr className={tbl.headRow}>
            <th className={tbl.th}>Merchant</th>
            <th className={cn(tbl.th, tbl.num)}>Legs</th>
            <th className={cn(tbl.th, tbl.num)}>Median orders</th>
            <th className={cn(tbl.th, tbl.num)}>Service p50</th>
            <th className={cn(tbl.th, tbl.num)}>s / package</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((m) => (
            <tr key={m.merchant_id} className={tbl.row}>
              <td className={tbl.td}>
                <span dir="auto">{m.merchant_name}</span> <span className={tbl.muted}>#{m.merchant_id}</span>
              </td>
              <td className={cn(tbl.td, tbl.num)}>{m.legs}</td>
              <td className={cn(tbl.td, tbl.num)}>{m.median_orders}</td>
              <td className={cn(tbl.td, tbl.num, m.classification === 'wait_heavy' && 'font-medium text-red-600')}>
                {m.service_p50_min} m
              </td>
              <td className={cn(tbl.td, tbl.num, m.classification === 'bulk' && 'font-medium text-emerald-700')}>
                {m.per_package_p50_s}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function MerchantPanels({ merchants }: { merchants: MerchantServiceRow[] }) {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Panel
        title="Wait-heavy merchants"
        subtitle="Driver waits while orders get prepared (high s/package on small pickups) — warn or reschedule."
      >
        <MerchantTable
          rows={merchants.filter((m) => m.classification === 'wait_heavy')}
          emptyText="No wait-heavy merchants in this window."
        />
      </Panel>
      <Panel
        title="Bulk merchants — big but healthy"
        subtitle="Long visits driven by volume, normal per-package pace — a route-sizing input, not a problem."
      >
        <MerchantTable
          rows={merchants.filter((m) => m.classification === 'bulk')}
          emptyText="No bulk merchants in this window."
        />
      </Panel>
    </div>
  );
}
